import security from '../../../utils/security'
import http from '../../../utils/http'
import {
  AGREEMENT_DOCUMENT_LOADING,
  AGREEMENT_DOCUMENT_SUCCESS,
  AGREEMENT_DOCUMENT_ERROR,
} from './mutation-types'

const state = {
  loading: false,
  error: '',
  generated: {}
}

function error (error) {
  return {type: AGREEMENT_DOCUMENT_ERROR, error}
}

function loading (loading) {
  return {type: AGREEMENT_DOCUMENT_LOADING, loading}
}

function success (generated) {
  return {type: AGREEMENT_DOCUMENT_SUCCESS, generated}
}

function updateAgreementData (retrieved) {
  return {type: 'agreement/update/AGREEMENT_UPDATE_RETRIEVE_SUCCESS', retrieved}
}

const getters = {
  error: state => state.error,
  generated: state => state.generated,
  loading: state => state.loading,
}

const actions = {
  generate ({commit}, agreementId) {
    commit(loading(true))
    commit(error(null))
    const page = '/agreements/' + agreementId + '/generate_documents'

    return http.fetch(page, {method: 'PUT'})
      .then(response => {
        commit(loading(false))
        return response.json()
      })
      .then(data => {
        commit(success(data))
        commit(updateAgreementData(data), {root: true})
      })
      .catch(e => {
        commit(loading(false))
        if (security.handleAuthorizationError(e)) {
          return
        }
        commit(error(e.message))
      })
  },
}

const mutations = {
  [AGREEMENT_DOCUMENT_ERROR] (state, payload) {
    state.error = payload.error
  },
  [AGREEMENT_DOCUMENT_LOADING] (state, payload) {
    state.loading = payload.loading
  },
  [AGREEMENT_DOCUMENT_SUCCESS] (state, payload) {
    state.generated = payload.generated
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/agreement/document.js